// dependencies
import React from "react";
import { Link } from "yarrr";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

// components
import Grid from "../../Components/Grid";
import Button from "../../Components/Button";
import Table from "../../Components/TableLite";
import { getFeatureFlags } from "../../Api/services/featureFlags";
import { getCurrentEnvironment } from "../../Selectors/app";

// css
import css from "./FeatureFlags.styl";

const FeatureFlagsTable = () => {
	const columns = [
		{
			id: "name",
			sortName: "name",
			label: "Name",
			width: "1fr",
			getter: (row) => (
				<Link className={css.flagLink} href={`/feature-flags/${row._id}`}>
					{row.name}
				</Link>
			),
		},
		{
			id: "category",
			sortName: "category",
			label: "Category",
			width: "1fr",
			getter: (row) => row.category,
		},
		{
			id: "type",
			sortName: "type",
			label: "Type",
			width: "1fr",
			getter: (row) => row.type,
		},
		{
			id: "created_at",
			sortName: "created_at",
			label: "Created At",
			width: "1fr",
			getter: (row) => {
				try {
					return format(new Date(row.created_at), "MMM d, yyyy h:mm a");
				} catch (error) {
					return "";
				}
			},
		},
		{
			id: "initial_value",
			sortName: "initial_value",
			label: "Initial Value",
			width: "1fr",
			getter: (row) => {
				if (row.type === "json") {
					return JSON.stringify(row.initial_value);
				}

				if (row.type === "boolean") {
					return row.initial_value ? "Visible" : "Hidden";
				}

				return row.initial_value?.toString();
			},
		},
	];

	const env = useSelector(getCurrentEnvironment);

	const { data } = useQuery({
		queryKey: ["feature-flags", env.name],
		queryFn: () => getFeatureFlags(env.name),
	});

	const rows = data?.featureFlags || [];

	return <Table rows={rows} columns={columns} />;
};

const FeatureFlags = () => {
	return (
		<div>
			<div className={css.content}>
				<div className={css.section}>
					<div className={css.sectionInformation}>
						<div className={css.title}>Feature Flags</div>
						<Grid columns={["600px", "1fr", "120px"]}>
							<div>
								<div className={css.description}>
									Feature flags are used to enable or disable features in the application. This is
									useful for testing features before they are released to the public.
								</div>

								<div className={css.description}>
									View the <Link href="/feature-flags/matrix">Feature Flag Matrix</Link> to see which
									feature flags are enabled for which companies.
								</div>
							</div>

							<div />

							<Button href="/feature-flags/create">Add Flag</Button>
						</Grid>
					</div>

					<div className={css.sectionContent}>
						<FeatureFlagsTable />
					</div>
				</div>
			</div>
		</div>
	);
};

export default FeatureFlags;
